import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../service/auth.service';
import { ButtonUI, InputUI } from '../Interface';
import useUsers from '../../context/UsersContext';
import useMenus from '../../context/MenuContext';
import appService from '../../service/app.service';
import usePages from '../../context/PageContext';
import useParam from '../../context/ParamContext';
import useConfig from '../../context/ConfigContext';
import useWmsParam from '../../context/WmsParamContext';
import masterDataService from '../../service/masterData.service';
import useSimpleTaskDeadLineNotify from '../../context/SimpleTaskDeadLineNotifyContext';
import simpleTaskDeadLineNotificationService from '../../service/simpleTaskDeadLineNotification.service';
import wmsParamService from '../../service/wms/wmsParam.service';
import { endSession, getSessionGeneration, getStoredSessionHomePage, isCurrentSession } from '../../utils/authSession';

export default function Auth() {
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginData, setLoginData] = useState({
    userName: '',
    password: '',
  });

  const { setPages } = usePages();
  const { setUser } = useUsers();
  const { setMenus, setResolvedMenuRoutes } = useMenus();
  const { setParam } = useParam();
  const { setConfig } = useConfig();
  const { setWmsParam } = useWmsParam();
  const { setSimpleTaskDeadLineNotify } = useSimpleTaskDeadLineNotify();

  const login = async (event) => {
    event.preventDefault();
    const homePage = getStoredSessionHomePage();
    if (homePage) {
      window.location.replace(homePage);
      return;
    }
    if (loggingIn || loginData.userName.length < 1 || loginData.password.length < 1) return;

    setLoggingIn(true);
    const attempt = authService.login(loginData);
    const generation = getSessionGeneration();
    let authenticated = false;
    try {
      const data = await attempt;
      authenticated = true;
      const views = data.views ? JSON.parse(data.views) : {};
      if (!views.ganttFilter) {
        views.ganttFilter = { task: true, production: true };
      }
      data.views = views;

      const [menuData, paramsData, configData, wmsParamsData, userData, simpleTaskNotifyData] = await Promise.all([
        appService.getMenuData(),
        appService.getParams(),
        appService.getConfig(),
        wmsParamService.getAll(),
        masterDataService.roleListsByRoleId(data?.roleId),
        simpleTaskDeadLineNotificationService.getData(),
      ]);
      if (!isCurrentSession(generation)) return;
      setMenus(menuData);
      setResolvedMenuRoutes([]);
      setPages({});
      setParam(paramsData);
      setConfig(configData);
      setWmsParam(wmsParamsData);
      setUser({
        ...data,
        roleLists: userData,
      });
      setSimpleTaskDeadLineNotify(simpleTaskNotifyData);
      window.location.replace(data.homePage ? `/app/${data.homePage}` : '/app');
    } catch {
      if (isCurrentSession(generation)) {
        if (authenticated) await authService.logout().catch(() => {});
        else endSession();
      }
    } finally {
      setLoggingIn(false);
    }
  };
  const homePage = getStoredSessionHomePage();
  if (homePage) return <Navigate to={homePage} replace />;

  return (
    <div className="flex h-screen">
      <div
        className={
          'flex flex-1 flex-col justify-center overflow-auto px-4 py-12 transition-colors duration-1000 sm:px-6 lg:flex-none lg:px-20 xl:px-24'
        }
      >
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div>
            <img className="h-12 w-auto" src="/quantlogo.png" alt="Logó" />
            <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-700"> Bejelentkezés</h2>
          </div>
          <div className="mt-8">
            <div className="mt-6">
              <form onSubmit={login} className="space-y-6">
                <div>
                  <div className="mt-2">
                    <InputUI
                      type="text"
                      name="userName"
                      label="Felhasználónév"
                      variant="standard"
                      id="userName"
                      value={loginData.userName}
                      required
                      onChange={(e) => setLoginData({ ...loginData, userName: e.target.value })}
                    />
                  </div>
                </div>
                <div>
                  <div className="mt-2">
                    <InputUI
                      label="Jelszó"
                      variant="standard"
                      type="password"
                      name="password"
                      id="password"
                      value={loginData.password}
                      required
                      onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                    />
                  </div>
                </div>
                <ButtonUI
                  text="Bejelentkezés"
                  type="submit"
                  disabled={loggingIn}
                  className="flex justify-center rounded-md bg-[#0076f8] px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 hover:enabled:bg-indigo-500 disabled:cursor-not-allowed disabled:opacity-50"
                ></ButtonUI>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="relative hidden w-0 flex-1 lg:block">
        <img className="absolute inset-0 top-[250px] object-cover" src="/innovative.jpg" alt="" />
      </div>
    </div>
  );
}
